import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// ASSETS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTrash, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useMainContext } from "../../../../contexts/MainContext";

// COMPONNENTS
import SortHeader from "../../../../components/atoms/SortHeader";
import InputCheckboxList from '../../../../components/atoms/InputCheckboxList';
import ModalAddMasterItem from '../../../../components/atoms/ModalAddMasterItem';

const TableMasterItems = ({ openDeletModal, openDownload }) => {
    const [selectedStates, setSelectedStates] = useState([]);
    const [showModal, setShowModal] = useState(false);
    let mainContext = useMainContext();

    const closeModal = () => {
        setShowModal(false)
        mainContext.setIsLoading(false);
    }


    // 🔥 FILAS QUEMADAS
    const staticRows = [
        {
            id: "IMP0001",
            nombreMasterItem: "La Nacional",
            PrimeraFechaUso: "Uso Mixto",
            UltimaFechaUso: "21/02/2025",
            dueno: "Camilo Blanco",
            tipo: "México",
            valor: "Monterrey",
            estado: "Activo"
        },
        {
            id: "IMP0002",
            nombreMasterItem: "The Crown Cantera",
            PrimeraFechaUso: "The Crown Cantera",
            UltimaFechaUso: "21/02/2025",
            dueno: "Nathalia G",
            tipo: "México",
            valor: "Ciudad de México",
            estado: "Activo"
        },
        {
            id: "IMP0003",
            nombreMasterItem: "Palmez",
            PrimeraFechaUso: "Palmez",
            UltimaFechaUso: "21/02/2025",
            dueno: "Arturo P",
            tipo: "México",
            valor: "Querétaro",
            estado: "Activo"
        }
    ];

    const handleStateChange = (paramName, value) => {
        setSelectedStates(value);
    };

    const myCatalog = [
        { countryID: 1, countryName: "" }
    ];

    const stateTemplate = (rowData) => {
        return (
            <InputCheckboxList
                cssClass=""
                catalog={myCatalog}
                currentData={selectedStates}
                handleData={handleStateChange}
                idProperty="countryID"
                displayName="countryName"
                paramName="state"
            />
        );
    };


    return (
        <div className="datatable-responsive-demo mt-4 tableImporters">
            <DataTable
                value={staticRows}
                className="p-datatable-striped"
                tableStyle={{ 'table-layout': 'auto' }}
                emptyMessage="No se encontraron datos"
            >
                <Column field="id" header={<SortHeader label="ID" />} />
                <Column field="nombreMasterItem" header={<SortHeader label="Nombre del Master Item" />}
                    body={(row) => <a onClick={() => { setShowModal(true) }} className="anchorBlue">{row.nombreMasterItem}</a>}
                />
                <Column field="PrimeraFechaUso" header={<SortHeader label="Primera fecha de uso" />}
                    body={(row) => <a className="anchorBlue">{row.PrimeraFechaUso}</a>}
                />
                <Column field="UltimaFechaUso" header={<SortHeader label="Ultima fecha de uso" />} />
                <Column field="dueno" header={<SortHeader label="Dueño" />} />
                <Column field="tipo" header="Tipo" />
                <Column field="valor" header="Valor" />
                <Column field="estado" header="Estado" body={stateTemplate} />
            </DataTable>
            <div className="mt-4 text-right">
                <button className="btn">
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button className="btn">
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
            <ModalAddMasterItem mode="edit" showModal={showModal} setShow={closeModal} />
        </div>
    );
}

export default TableMasterItems;